export const publicUrl = (url) => process.env.REACT_APP_UPLOAD + '/' + url;
